import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  AuraLayout,
  Button,
  CashSpecialIcon,
  Layout,
  PageTitle,
  RoundedCheckIcon,
} from "lola-framework-ui-test";
import { FlowHeroMark } from "../../components/FlowHeroMark";
import { FUND_REQUEST_ROUTES, TITLE_COLOR } from "../../constants";
import { useStore } from "../../store/globalState";
import { formatLabeledAmount } from "../../utils";
import { ScrollFadeIndicator } from "../../components/ScrollFadeIndicator";

/**
 * In-progress commit after CIP (live SendingMoneyPage before the operation
 * exists): spinner + cash + "Transfiriendo" + amount.
 */
export const TransferringPage = memo(() => {
  const { t } = useTranslation("fund-request");
  const { theme, amountState } = useStore();

  const colorConfig = theme.whiteView;
  const { dropzoneColors, backgroundIcon } = colorConfig;
  const displayAmount = parseFloat(amountState.amount ?? "0") || 0;

  return (
    <AuraLayout colorConfig={colorConfig} className="flow-landing-page">
      <Layout.Content className="landing-section flow-hero-section">
        <ScrollFadeIndicator color={colorConfig.bodyCopy} />
        <section className="flow-hero">
          <FlowHeroMark
            showSpinner
            dropzoneColors={dropzoneColors}
            backgroundIcon={backgroundIcon}
          >
            <CashSpecialIcon size={60} colors={dropzoneColors} />
          </FlowHeroMark>
          <section className="landing-container">
            <PageTitle
              highlight={t("transfer.transferring")}
              highlightColor={TITLE_COLOR}
              secudnary={formatLabeledAmount(displayAmount, "USD")}
              secudnaryColor={TITLE_COLOR}
            />
          </section>
        </section>
      </Layout.Content>
    </AuraLayout>
  );
});

/**
 * Terminal success view after transferring (live SendingMoneyPage once the
 * operation exists). Gallery-only: Done returns to the transactions list.
 */
export const SendingMoneyPage = memo(() => {
  const { t } = useTranslation("fund-request");
  const { theme } = useStore();
  const navigate = useNavigate();

  const colorConfig = theme.whiteView;
  const { backgroundBtn, textColorBtn, dropzoneColors, backgroundIcon } = colorConfig;

  return (
    <AuraLayout colorConfig={colorConfig} className="flow-landing-page">
      <Layout.Content className="landing-section flow-hero-section">
        <ScrollFadeIndicator color={colorConfig.bodyCopy} />
        <section className="flow-hero">
          <FlowHeroMark
            dropzoneColors={dropzoneColors}
            backgroundIcon={backgroundIcon}
          >
            <RoundedCheckIcon size={60} colors={dropzoneColors} />
          </FlowHeroMark>
          <section className="landing-container">
            <PageTitle
              highlight={t("transfer.transferProcessedTitle")}
              highlightColor={TITLE_COLOR}
              secudnary={t("transfer.transferProcessedSubtitle")}
              secudnaryColor={TITLE_COLOR}
            />
          </section>
        </section>
      </Layout.Content>
      <Layout.Footer>
        <section className="footer-section">
          <Button
            size="large"
            background={backgroundBtn}
            color={textColorBtn}
            onClick={() => navigate(FUND_REQUEST_ROUTES.TRANSACTIONS)}
          >
            {t("transfer.done")}
          </Button>
        </section>
      </Layout.Footer>
    </AuraLayout>
  );
});
